/**
 * @module app.shared
 */

import { useView, autoinject, PLATFORM } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { OpenFlags } from 'app/shared/flags/open-flags';
import { IPopup, PopupBase } from 'app/shared/elements/popup-base';
import { fireEventOn } from 'app/shared/lib/fire-events';
import { confirmation } from 'app/shared/elements/ess-confirm';

export interface IDialog extends DialogBase {
    isDismissible: boolean;
}

@autoinject()
abstract class DialogBase extends PopupBase implements IPopup {

    public $body!: HTMLElement;

    @bindable.boolean()
    public isDismissible: boolean = false;
    protected OpenFlags = OpenFlags;

    @bindable.boolean()
    public confirmClose: boolean = false;
    @bindable.string()
    public confirmType: string | null = null;
    @bindable.string()
    public confirmMessage: string | null = null;

    labelledbyId = `${this.id}-header`;

    protected handleBackdropMousedown(event: MouseEvent) {
        if(this.isDismissible && event.target === this.element) {
            this.close(true);
        }
        if(!this.isDismissible && event.target === this.element) {
            const dialogContainer: HTMLElement | null = this.element.querySelector(".ess-dialog");
            dialogContainer!.focus();
            return false;
        }
        return true;
    }

    protected labelledbyIdChanged(newValue?: string) {
        if(!newValue) {
            this.labelledbyId = `${this.id}-header`;
        }
    }

    protected shouldDismiss(event: Event) {
        if(event instanceof KeyboardEvent) {
            return super.shouldDismiss(event)
        }
        return this.isDismissible && super.shouldDismiss(event);
    }

    public async close(showConfirm?: boolean) {
        if(showConfirm && this.confirmClose && this.confirmType && this.confirmMessage) {
            if(this.confirmType === 'cancelChanges') {
                const result = await confirmation.showCancelChanges(this.confirmMessage);
                if(!(result.dialogResponse === confirmation.options.OK)) return;
            }
        }

        if(this.state & OpenFlags.Open && fireEventOn(this.element, 'closing')) {
            this.state = OpenFlags.Closing;
            this.focusPrior();
        }
    }

}

@useView(PLATFORM.moduleName('./ess-dialog.html'))
export class EssDialogCustomElement extends DialogBase {
    isDismissible = true;

    @bindable.string()
    public testName: string = '';
}

@useView(PLATFORM.moduleName('./ess-dialog.html'))
export class EssModalCustomElement extends DialogBase {
    isDismissible = false;

    @bindable.string()
    public testName: string = '';
}
